// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material';

export default makeStyles()((theme: Theme) => ({
  inputField: {
    marginTop: 10,
    color: theme.palette.primary.main,
    '& .MuiOutlinedInput-input': {
      color: theme.palette.text.primary,
    },
  },

  inputFieldLabel: {
    color: theme.palette.getContrastText(theme.palette.background.paper),
  },

  inputValidationMessage: {
    color: theme.palette.error.main,
  },

  selectLabel: {
    color: theme.palette.grey[400],
    marginTop: 4,
  },

  fullWidth: {
    width: '100%',
  },

  actionSelect: {
    '& .MuiSelect-select': {
      paddingLeft: 10,
      paddingRight: 0,
      paddingTop: 1,
      paddingBottom: 0,
    },
    fontWeight: 700,
    color: theme.palette.primary.main,
  },
}));
